import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "footer" }

import { ElButton, ElTabs, ElMessage } from "element-plus"
import { ref } from "vue";
import { useAreaContext } from "../context";
import type { District } from "../../../api/types";

import LeftSlider from "./left-slider.vue";
import ProvincePanel from "./province-panel.vue";
import CityPanel from "./city-panel.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'area-picker-panel',
  emits: ['confirm', 'cancel'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { model } = useAreaContext()!

const emit = __emit

const activeTab = ref('province')
const provincePanel = ref()
const cityPanel = ref()

const handleSelectProvince = (value: District) => {
  activeTab.value = 'city'
  
  if (model.province?.districtID !== value.districtID) {
    model.city = undefined
  }
  model.province = value
}

const handleSelectCity = (value: District) => {
  model.city = value || {}
}

const onReset = () => {
  model.province.districtName = ''
  model.city.districtName = ''
}
const onConfirm = () => {
  if (!model.province) {
    return ElMessage.warning('请选择省市')
  }
  if (!model.city) {
    return ElMessage.warning('请选择城市')
  }
  emit('confirm')
}
const onCancel = () => {
  emit('cancel')
}

__expose({
  reset: () => {
    activeTab.value = 'province'
    provincePanel.value?.reset()
    cityPanel.value?.reset()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElTabs), {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElTabs).TabPane, {
          name: "province",
          label: _unref(model).province ? _unref(model).province.districtName : '全国'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(LeftSlider, {
                "active-tab": activeTab.value,
                "onUpdate:activeTab": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
              }, null, 8, ["active-tab"]),
              _createVNode(ProvincePanel, {
                ref_key: "provincePanel",
                ref: provincePanel,
                onSelect: handleSelectProvince
              }, null, 512)
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(model).province)
          ? (_openBlock(), _createBlock(_unref(ElTabs).TabPane, {
              key: 0,
              name: "city",
              label: _unref(model).city ? _unref(model).city.districtName : '选择市'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(LeftSlider, {
                    "active-tab": activeTab.value,
                    "onUpdate:activeTab": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
                  }, null, 8, ["active-tab"]),
                  _createVNode(CityPanel, {
                    ref_key: "cityPanel",
                    ref: cityPanel,
                    provinceDistrID: _unref(model).province.districtID,
                    onSelect: handleSelectCity
                  }, null, 8, ["provinceDistrID"])
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1)),
      _withDirectives(_createVNode(_unref(ElButton), {
        class: "btn",
        onClick: onReset
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("重置")
        ])),
        _: 1
      }, 512), [
        [_vShow, false]
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(ElButton), {
          class: "btn",
          onClick: onCancel
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          type: "primary",
          class: "btn",
          onClick: onConfirm
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}
}

})